import { ID } from "@voomp/play-back"

const toggles = {
  watch: "2" // 1 | 2
}

function watchV3(courseId: ID, moduleId?: ID, lessonId?: ID) {
  if (courseId && moduleId && lessonId) {
    return `/my-courses/watch/course/${courseId}/module/${moduleId}/lesson/${lessonId}`
  } else if (courseId && moduleId) {
    return `/my-courses/watch/course/${courseId}/module/${moduleId}`
  } else if (courseId) {
    return `/my-courses/watch/course/${courseId}`
  } else {
    console.error("watchPath no parameter found")
    return null
  }
}


function watch(courseId: ID, moduleId?: ID, lessonId?: ID) {
  return watchV3(courseId, moduleId, lessonId)
}

export const paths = {
  toggles,
  watch,
  watchV3
};

globalThis.paths = paths;
